import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Importacion de Librerias
import { Observable, catchError, of } from 'rxjs';
// Importacion de Variables de Entorno
import { Environment } from 'src/environments/environment';
// Importacion de Interfaces
import { InterfaceParams } from 'src/app/interfaces/general/params.interface';

@Injectable({
  providedIn: 'root'
})
export class EndpointService {
  public endpoint: string = Environment.backend;

  constructor(
    public http: HttpClient
  ) { }

  private testUrl(): boolean {
    // Expresión regular para validar una URL
    const urlPattern = /^https?:\/\/\w+\.\w+/;
    return urlPattern.test(this.getEndpoint());
  }

  public buildApiUrl(endpoint: string, params: Record<string, any>): string {
    const queryParams = new URLSearchParams(params).toString();
    const formatParams = `${queryParams ? '?' + queryParams : ''}`;
    return `${this.getEndpoint()}${endpoint}${formatParams}`;
  }

  public processParams(params: InterfaceParams) {
    // Crea un nuevo objeto y copia todas las propiedades
    const rest = { ...params };
    const query: InterfaceParams = rest;
    return query;
  }

  getEndpoint() {
    return this.endpoint;
  }

  getAvailability(): Observable<any> {
    // Realiza una solicitud HTTP GET a la URL
    return this.http.get(
      this.getEndpoint(),
      { observe: 'response' }
    ).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  getCheckUrl() {
    return this.testUrl();
  }

  getCurrentUrl(): string {
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
  }

  getCurrentExt(): string {
    const { hostname } = window.location;
    const parts = hostname.split('.');
    if (parts.length > 1) {
      // Verificar si la primera parte es un número (indicativo de una IP)
      if (!isNaN(parseInt(parts[0]))) { return ''; }
      return parts[parts.length - 1];
    }
    return '';
  }
}
